/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowaddenglish3Inputs */

const en_aiflowaddenglish3 = /** @type {(inputs: Aiflowaddenglish3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English version`)
};

const de_aiflowaddenglish3 = /** @type {(inputs: Aiflowaddenglish3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Englische Fassung`)
};

/**
* | output |
* | --- |
* | "English version" |
*
* @param {Aiflowaddenglish3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowaddenglish3 = /** @type {((inputs?: Aiflowaddenglish3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowaddenglish3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowaddenglish3(inputs)
	return de_aiflowaddenglish3(inputs)
});
export { aiflowaddenglish3 as "aiFlowAddEnglish" }